import Utils from "../../misc/Utils";

class StoriesModel {
    constructor(parent) {
        this.parent = parent;
        this.limit = this.parent.$wrapper.attr('data-stories-limit');
        this.sorting = this.parent.$wrapper.attr('data-stories-sort');
        this.page = parseInt(this.parent.$wrapper.attr('data-stories-page'));
        this.leftOffset = (this.page - 2) * this.limit;
        this.rightOffset = this.page * this.limit;
        this.shouldFetchLeft = true;
        this.shouldFetchRigh = true;
        this.isFetchingThumbs = false;
        this.storageKey = 'stories-history-stack';
        this.seenIds = Utils.getFromStorage(this.storageKey);
        this.activeStory = {
            'setId' : function(id) {
                this.id = id;
                this.$el = jQuery('[data-story-id="'+id+'"]');
                this.arrayIndex = StoriesModel._stories.indexOf(id);
            },
            'id' : null,
            '$el' : null,
            'arrayIndex' : -1
        };
    }
    static set stories(id){
        return StoriesModel._stories = id;
    }
    static get stories(){
        if(typeof this._stories === 'undefined'){
            this._stories = [];
        }
        return this._stories;
    }
    getStoriesArray(){
        let stories = [];
        let $storiesThumbs = jQuery('[data-show-story]');
        $storiesThumbs.each((index) => {
            let id = jQuery($storiesThumbs[index]).attr('data-show-story');
            if(stories.indexOf(id) === -1) {
                stories.push(id);
            }
        });
        StoriesModel._stories = stories;
    }
    pushToSeenIDs(){
        if(this.seenIds) {
            if (this.seenIds.indexOf(this.activeStory.id) === -1) {
                this.seenIds.push(this.activeStory.id);
            }
            if(this.parent.isSlider) {
                Utils.pushToStorage(this.storageKey, JSON.stringify(this.seenIds));
            }
        }
    }
    getPreviousStoryId() {
        let index = this.activeStory.arrayIndex;
        if(index > 1) {
            return StoriesModel._stories[index - 2];
        }
        return false;
    }
    getNextStoryId() {
        let index = this.activeStory.arrayIndex;
        if(index < StoriesModel._stories.length - 2) {
            return StoriesModel._stories[index + 2];
        }
        return false;
    }
    getAdjacentStoriesIds(id){
        let ids = [];
        let index = StoriesModel._stories.indexOf(id);
        if(index > 0) {
            ids.push(StoriesModel._stories[index-1]);
        }
        ids.push(id);
        if(index < StoriesModel._stories.length - 1) {
            ids.push(StoriesModel._stories[index + 1]);
        }
        return ids;
    }
    excludeFetchedIds(ids) {
        let clean = [];
        ids.forEach(function (id) {
            if(jQuery('[data-story-id="'+id+'"]').length === 0) {
                clean.push(id);
            }
        });
        return clean;
    }
    fetchStoriesModalByIds(ids, successCallback, errorCallback) {
        ids = this.excludeFetchedIds(ids);
        if(ids.length <= 0) {
            if(successCallback) {
                successCallback();
            }
            return false;
        }
        Utils.commit_ajax_action('fetch_stories', {
            'ids': JSON.stringify(ids)
        }, function(response) {
            if(response && response.status && response.status === 'error') {
                if(errorCallback) {
                    errorCallback();
                }
                return false;
            }
            if(successCallback) {
                successCallback(response);
            }
        }, function() {
            if(errorCallback) {
                errorCallback();
            }
        });
    }
    onFetchStoriesThumbs(stories, prepend) {
        if(prepend) {
            stories = stories.reverse();
            this.leftOffset = this.leftOffset - stories.length;
            this.page = this.page - 1;
        } else {
            this.rightOffset = this.rightOffset + stories.length;
            this.page = this.page + 1;
        }
        for(let index in stories) {
            let id = stories[index].id;
            if(StoriesModel._stories.indexOf(id) === -1) {
                if(prepend) {
                    StoriesModel._stories.unshift(id);
                    if(this.seenIds.indexOf(stories[index].id) !== -1) {
                        stories[index]['extra_class'] = 'seen';
                    }
                } else {
                    StoriesModel._stories.push(id);
                    if(this.seenIds.indexOf(stories[index].id) !== -1) {
                        stories[index]['extra_class'] = 'seen';
                    }
                }
            }
        }
        //re-index active story
        this.activeStory.arrayIndex = StoriesModel._stories.indexOf(this.activeStory.id);
        return stories;
    }
    fetchStoriesThumbs(prepend, successCallback, errorCallback) {
        prepend = (typeof prepend === 'undefined')? false : prepend;
        let self = this;
        let offset = this.rightOffset;
        if(prepend) {
            offset = this.leftOffset;
        }
        if(offset < 0 || (offset === 0 && this.page === 1)) {
            if(successCallback) {
                successCallback();
            }
            return false;
        }
        if(this.isFetchingThhumbs || (prepend && !this.shouldFetchLeft) || (!prepend && !this.shouldFetchRigh)) {
            return false;
        }
        this.isFetchingThhumbs = true;
        Utils.commit_ajax_action('fetch_stories_thumbs', {
            'limit' : self.limit,
            'offset': offset,
            'sorting' : self.sorting
        }, (response) => {
            this.isFetchingThhumbs = false;
            if((response && response.status && response.status === 'error') || response.cargo.stories.length === 0) {
                if(prepend) {
                    this.shouldFetchLeft = false;
                } else {
                    this.shouldFetchRigh = false;
                }
                if(errorCallback) {
                    errorCallback();
                }
                return false;
            }
            let stories = response.cargo.stories;
            if(stories.length > 0) {
                stories = this.onFetchStoriesThumbs(stories, prepend);
            }
            if(successCallback) {
                successCallback(stories);
            }
        }, () => {
            this.isFetchingThumbs = false;
            if(prepend) {
                this.shouldFetchLeft = false;
            } else {
                this.shouldFetchRigh = false;
            }
            if(errorCallback) {
                errorCallback();
            }
        });
    }
}

export default StoriesModel;